import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye } from 'react-icons/fa';
import { getDisplayValue } from "../../../utils/displayValue";


function AcceptedApplications({ applications = [], formatDate, consultants = [], fetchConsultants, fetchApplications }) {

    const navigate = useNavigate();


    return (
        <>
            <div className="flex flex-wrap space-x-6">
                <div className="flex flex-col space-y-6 w-full">

                    {/* Applications with Remarks */}
                    <div className="px-10 py-6 bg-white rounded ">
                        <table className="w-full table-auto border-t border-b border-gray-300">
                            <thead>
                                <tr className="border-b border-gray-300">
                                    <th className="px-4 py-2 text-center text-gray-400">Application ID</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Student Name</th>
                                    <th className="px-4 py-2 text-center text-gray-400">University</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Country</th>
                                    <th className="px-4 py-2 text-center text-gray-400">City</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Date of Submission</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Consultant</th>
                                    <th className="px-4 py-2 text-center text-gray-400">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {applications.length > 0 ? applications.map((application) => (
                                    <tr
                                        key={application._id}
                                        className="border-b border-gray-300 cursor-pointer text-center"
                                    >
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.customApplicationId)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.fullName)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.university)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.country)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.city)}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{formatDate(application.applicationDate) || 'N/A'}</td>
                                        <td className="px-4 py-4 text-sm text-gray-700">{getDisplayValue(application.consultantName)}</td>
                                        <td className="pl-4 py-4 text-sm font-thin flex items-center justify-center space-x-2">
                                            <button
                                                onClick={() => navigate(`/admin/application-details`, { state: { id: application._id } })}
                                                className="p-1 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                                                title="Save"
                                            >
                                                <FaEye className="size-4" />
                                            </button>
                                        </td>
                                    </tr>
                                )) : <tr><td colSpan={8} className="text-center text-gray-700 py-4">No applications available</td></tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AcceptedApplications;
